import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';
import Main from "./Main";
import './index.css';
import { TransitionProvider } from "react-router-simple-transition";
import * as serviceWorker from './serviceWorker';

const supportsHistory = 'pushState' in window.history;

ReactDOM.render(
	<HashRouter forceRefresh={!supportsHistory}>
		<TransitionProvider>
			<Main/>
		</TransitionProvider>
	</HashRouter>, document.querySelector('#root')
);

serviceWorker.register();